// extracted by mini-css-extract-plugin
export default {"assembly-selection-table":"AssemblySelectionTable_assembly-selection-table__2-jqT"};